import type { Action } from 'vuex'
import type { CorpParams, State } from './state'
import type {
  QueryDirectCorpListModel,
} from '@/api/direct_send/model/sendDirectModel'

import actionTypes from './actionTypes'
import { queryDirectCorpList } from '@/api/direct_send/direct_send'

const actions: { [actionTypes: string]: Action<State, any> } = {
  [actionTypes.SET_DIRECT_CORP_DETAIL]: async ({ commit, state }): Promise<void> => {
    // リストを取得
    const result: QueryDirectCorpListModel | undefined =
      await queryDirectCorpList(state.params)
    
    commit(actionTypes.SET_DIRECT_CORP_DETAIL, result?.detail ?? [])
    commit(actionTypes.SET_TOTAL_COUNT, result?.total_count ?? 0)
  },

  [actionTypes.SET_PARAMS]: ({ commit }, params: CorpParams): void => {
    commit(actionTypes.SET_PARAMS, params)
  },
}

export default actions
